import React from 'react';

interface DragHandleProps {
  className?: string;
}

export const DragHandle: React.FC<DragHandleProps> = ({ className = '' }) => {
  return (
    <div className={`drag-handle ${className}`} title="Drag to reorder"/>
  );
}; 